
angular.module('bmsApp.employee').controller('EmployeeUpdateBulkCtrl', [
	'$scope',
	'$state',
	'$q',
	'notify',
	'EmployeeSvc',
	'EmployeeOptionsSvc', function (
		$scope,
		$state,
		$q,
		notify,
		EmployeeSvc,
		EmployeeOptionsSvc) {

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit($scope.selectedEmployees);
			},
			errorPlacement: function (error, element) {
				error.appendTo('#bulk-update-errors');
			},
			errorContainer: '#bulk-update-errors'
		};
		$scope.formHasErrors = false;

		$scope.loading = true;
		$scope.processing = false;
		$scope.selectedEmployees = {
			ids: []
		};
		$scope.employees = [];

		employeeOptionsAllPromise = EmployeeOptionsSvc.all();
		employeesPromise = EmployeeSvc.index();
		promises = [employeeOptionsAllPromise, employeesPromise];
		$q.all(promises).then(function (data) {
			$scope.loading = false;
			$scope.remunerationTypeOptions = data[0].remunerationType.options;
			$scope.employeeMileageRateOptions = data[0].employeeMileageRate.options;
			$scope.employeeGroupOptions = data[0].employeeGroups.group_options;
			$scope.employees = data[1].data.employee_collection;
		});

		$scope.remunerationTypeEnabledChange = function (remunerationTypeEnabled) {
			if (remunerationTypeEnabled != true) {
				delete $scope.selectedEmployees.remuneration_type_id;
			}
		};

		$scope.employeeGroupEnabledChange = function (employeeGroupEnabled) {
			if (employeeGroupEnabled != true) {
				delete $scope.selectedEmployees.employee_groups;
			}
		};

		$scope.$watch('selectedEmployees.remuneration_type_id', function (value) {
			if (value == 1) {
				$scope.selectedEmployees.pay_rate = 0;
				$scope.selectedEmployees.start_time = '00:00';
				$scope.selectedEmployees.end_time = '00:00';
			}
			else {
				delete $scope.selectedEmployees.pay_rate;
				delete $scope.selectedEmployees.start_time;
				delete $scope.selectedEmployees.end_time;
			}

			if (value == 2) {
				$scope.selectedEmployees.clean_rate = 0;
				$scope.selectedEmployees.travel_rate = 0;
			}
			else {
				delete $scope.selectedEmployees.clean_rate;
				delete $scope.selectedEmployees.travel_rate;
			}

			if (value == 3) {
				$scope.selectedEmployees.percentage = 0;
				$scope.selectedEmployees.minimum_hourly_rate = 0;
			}
			else {
				delete $scope.selectedEmployees.percentage;
				delete $scope.selectedEmployees.minimum_hourly_rate;
			}
		});

		$scope.employeeMileageRateEnabledChange = function (employeeMileageRateEnabled) {
			if (employeeMileageRateEnabled != true) {
				delete $scope.selectedEmployees.employee_mileage_rate_id;
			}
		};

		$scope.taxCodeEnabledChange = function (taxCodeEnabled) {
			if (taxCodeEnabled != true) {
				delete $scope.selectedEmployees.tax_code;
			}
		};

		$scope.submit = function (selectedEmployees) {
			$scope.processing = true;
			EmployeeSvc.updateBulk(selectedEmployees)
				.then(function (response) {
					notify({
						message: 'Employees updated successfully'
					});
					$state.go('main.employee.index');
				}, function (error) {
					notify({
						message: 'Failed to update employees',
						classes: 'error'
					});
				})
				.finally(function () {
					$scope.processing = false;
				});
		};
		
	}]);
